import React,{useEffect} from "react";
import { useDispatch } from "react-redux";
import DataTable from "examples/Tables/DataTable";
import {todayIncomeTable} from "../../../redux/actions/PaymentActions"
import { useSelector } from "react-redux";

const TodayIncome = (props) => {
  const dispatch = useDispatch()
  useEffect(()=>{
    dispatch(todayIncomeTable(props.buildingId))
  },[])
  // function select(state) {
  //   return state.some.deep.property
  // }
  const todayIncome = useSelector(state =>state.payments.todayIncome)
  console.log(todayIncome)
  const data = [
    { Header: "transactionDate", accessor: "transactionDate" },
    { Header: "transactionId", accessor: "transactionId" },
    { Header: "amountPaid", accessor: "amountPaid", width: "25%", color: "red" },
    { Header: "bedId", accessor: "bedId", width: "30%" },
    { Header: "guestName", accessor: "guestName", width: "12%" },
  ];
  return (
    <div>
    {!todayIncome.data ? (<strong>Loading....</strong>):(<DataTable
      canSearch="true"
      active='false'
      showTotalEntries='false'
      table={{
        columns: data,
        rows: todayIncome.data,
      }}
    />)}
    </div>
  );
};

export default TodayIncome;
